import { render, staticRenderFns } from "./REPORT_CREATED.vue?vue&type=template&id=96a2e908&"
import script from "./REPORT_CREATED.vue?vue&type=script&lang=js&"
export * from "./REPORT_CREATED.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports